"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentLanguage = void 0;
var react_redux_1 = require("react-redux");
var localisationSlice_1 = require("@store/slices/localisationSlice");
var react_1 = require("react");
// Хук для получения текущего языка
var useCurrentLanguage = function () {
    var lng = (0, react_redux_1.useSelector)(function (state) { return state.localisationSlice.currentLanguage; });
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        if (lng === undefined) {
            dispatch((0, localisationSlice_1.setLanguage)("en"));
        }
    }, [lng, dispatch]);
    return lng;
};
exports.useCurrentLanguage = useCurrentLanguage;
